import React from 'react';

const ServiceDisplay = ({ service, iframeKey, getServiceUrl }) => {
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <iframe
        key={iframeKey}
        src={getServiceUrl(service.id)}
        style={{
          width: '100%',
          height: 'calc(100vh - 115px)',
          border: 'none'
        }}
        title={service.name}
      />
    </div>
  );
};

export default ServiceDisplay; 